export function returnDateWeek (timestamp) {
    let time = '';
      if(typeof(timestamp) == 'string') {
        if(timestamp.indexOf('T')!=-1) {
          let dates = timestamp.replace(/-/g, '/').replace('T', ' ').replace('.', ' ').split(/\/|\:|\ /)
          time = new Date(dates[0],dates[1]-1,dates[2],dates[3],dates[4],dates[5]);
          time.setTime(time.setHours(time.getHours() + 8));
        } else {
          time = new Date(timestamp.replace(/-/g, '/'));
        }
      } else {
        time = new Date(timestamp);
      }
      let week = time.getDay(); //获取时间的星期数，周日是0
      if(week == 0) {
        return `周日`;
      } else if(week == 1){
        return `周一`;
      } else if(week == 2){
        return `周二`;
      } else if(week == 3){
        return `周三`;
      } else if(week == 4){
        return `周四`;
      } else if(week == 5){
        return `周五`;
      } else if(week == 6){
        return `周六`;
      } 
};


// WEBPACK FOOTER //
// ./src/util/returnDateWeek.js